import { MaintenancePlanGroupCreate } from "@boark/shared/types/maintenance-plan-group-create";
import { MaintenancePlanGroupUpdate } from "@boark/shared/types/maintenance-plan-group-update";
import {
  MaintenancePlanGroupWithCodes,
  maintenancePlanGroupWithCodesSchema,
} from "@boark/shared/types/maintenance-plan-group-with-codes";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
  request,
} from "../utils/request";
import { recordIdToId } from "../utils/record-id-to-id";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getMaintenancePlanGroups(): Promise<
  MaintenancePlanGroupWithCodes[]
> {
  return request(`${API_BASE_URL}/maintenance-plan-group`, {
    schema: z.array(maintenancePlanGroupWithCodesSchema),
    headers: { "Content-Type": "application/json" },
  });
}

export async function getMaintenancePlanGroup(
  id: string,
): Promise<MaintenancePlanGroupWithCodes> {
  return getRequest(
    `${API_BASE_URL}/maintenance-plan-group/${id}`,
    maintenancePlanGroupWithCodesSchema,
  );
}

export async function createMaintenancePlanGroup(
  group: MaintenancePlanGroupCreate,
): Promise<MaintenancePlanGroupWithCodes> {
  return postRequest(
    `${API_BASE_URL}/maintenance-plan-group`,
    group,
    maintenancePlanGroupWithCodesSchema,
  );
}

export async function updateMaintenancePlanGroup(
  id: string,
  group: MaintenancePlanGroupUpdate,
): Promise<MaintenancePlanGroupWithCodes> {
  return putRequest(
    `${API_BASE_URL}/maintenance-plan-group/${id}`,
    group,
    maintenancePlanGroupWithCodesSchema,
  );
}

export async function deleteMaintenancePlanGroup(id: string): Promise<void> {
  return deleteRequest(`${API_BASE_URL}/maintenance-plan-group/${id}`);
}

export function formatMaintenancePlanCodeLabel({
  code,
  groupName,
}: {
  code: string;
  groupName: string;
}): string {
  return `${groupName} / ${code}`;
}

export function formatMaintenancePlanCodeOption(
  group: MaintenancePlanGroupWithCodes,
  code: { id: string; code: string },
): { label: string; value: string } {
  return {
    label: formatMaintenancePlanCodeLabel({
      code: code.code,
      groupName: group.name,
    }),
    value: recordIdToId(code.id),
  };
}
